import {
  createSlice,
} from '@reduxjs/toolkit';
import setEntitiesState, { setBaseState } from '../../../../../store/utils/setStoreState';
import setSupportPaymentMethodsState from './utils/setSupportPaymentMethodsState';
import setPayManualAndPayInfullState from './utils/setPayManualAndPayInfullState';
import setPaymentPlanStates from './utils/setPaymentPlanStates';

const paymentOptionsSlice = createSlice({
  name: 'paymentOptions',
  initialState: {
    entities: {
      paymentOptionData: {},
    },
    currentPaymentOptionType: '',
    isRenderPaymentOptions: false,
    supportPaymentMethods: [],
    paymentPlanOptions: [],
    isPayManual: false,
    isPayInfull: false,
    amountDue: undefined,
    creditBalance: undefined,
    useCreditBalance: false,
    updateBillingSchedule: false,
    paymentProcessingFee: 0,
    futurePaymentProcessingFeeAmount: 0,
    isPaymentProcessingFeeModel: false,
    paymentPlanIdAndGroups: [],
  },
  reducers: {
    setPaymentOptionData: setEntitiesState('paymentOptionData'),
    setCurrentPaymentOptionType: setBaseState('currentPaymentOptionType'),
    setIsRenderPaymentOptions: setBaseState('isRenderPaymentOptions'),
    setSupportPaymentMethods: setSupportPaymentMethodsState,
    setCurrentMethod: setBaseState('currentMethod'),
    setPayManualAndPayInfull: setPayManualAndPayInfullState,
    setPaymentPlans: setPaymentPlanStates,
    setUseCreditBalance: setBaseState('useCreditBalance'),
    setUpdateBillingSchedule: setBaseState('updateBillingSchedule'),
    setCreditBalance: setBaseState('creditBalance'),
    setAmountDue: setBaseState('amountDue'),
    setPaymentPlanOptions: setBaseState('paymentPlanOptions'),
    setPaymentProcessingFee: setBaseState('paymentProcessingFee'),
    setIsPaymentProcessingFeeModel: setBaseState('isPaymentProcessingFeeModel'),
    setPaymentPlanIdAndGroups: setBaseState('paymentPlanIdAndGroups'),
    setFuturePaymentProcessingFeeAmount: setBaseState('futurePaymentProcessingFeeAmount'),
  },
});

export const {
  setPaymentOptionData,
  setCurrentPaymentOptionType,
  setIsRenderPaymentOptions,
  setCurrentMethod,
  setPayManualAndPayInfull,
  setSupportPaymentMethods,
  setPaymentPlans,
  setUseCreditBalance,
  setUpdateBillingSchedule,
  setCreditBalance,
  setAmountDue,
  setPaymentPlanOptions,
  setPaymentProcessingFee,
  setIsPaymentProcessingFeeModel,
  setPaymentPlanIdAndGroups,
  setFuturePaymentProcessingFeeAmount,
} = paymentOptionsSlice.actions;

export default paymentOptionsSlice.reducer;
